
export const defaultPageSize = 20

export const defaultRowHeight = 40

export const defaultNullValue = -2

export const WEEK = ['日', '一', '二', '三', '四', '五', '六']

